import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=07a0800a&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=07a0800a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0800a",
  null
  
)

export default component.exports